export default __webpack_public_path__ + "static/media/box-search-order.637424e1.svg";